export class PolyLibsController {
  constructor() {
    this._rootPrefix = "";
    this._root = "/three/js/libs";
    this._KTX2Path = "/ktx2";
    this._DRACOPath = "/draco";
    this._DRACOGLTFPath = "/draco/gltf";
    this._XATLASPath = "/xatlas";
  }
  root() {
    if (this._root) {
      if (this._rootPrefix.length > 0) {
        const root = this._root.replace(/^(\.)/, "");
        return `${this._rootPrefix}${root}`;
      } else {
        return this._root;
      }
    }
  }
  setRoot(url) {
    this._root = url;
  }
  setRootPrefix(prefix) {
    this._rootPrefix = prefix;
  }
  KTX2Path() {
    return this._KTX2Path;
  }
  DRACOPath() {
    return this._DRACOPath;
  }
  DRACOGLTFPath() {
    return this._DRACOGLTFPath;
  }
  XATLASPath() {
    return this._XATLASPath;
  }
}
